import type { ConfigContract } from "../types";

export default {
  AUTH_TRUST_HOST: "true",
  NEXT_PUBLIC_APP_ENV: "uat",
  AUTH_SECRET: "secret",
  NEXTAUTH_URL: "https://travel-uat.gettameeni.com",
  TAMEENI_HOME: "https://qcmotor.gettameeni.com",
  API_BASE_URL: "https://travel-uat.gettameeni.com/backend/api/v1/",
  CONNECTION_API_URL:
    "https://travel-uat.gettameeni.com/backend/QuoteNotifierHub",
  AMEEN_URL: "https://qcmotor.gettameeni.com/ameen",
  IDENTITY_URL: "https://idpuat.gettameeni.com/",
  IDENTITY_CLIENT_ID: "travel-uat",
  IDENTITY_CLIENT_SECRET: "rasan@123",
  IDENTITY_REDIRECT_URL: "https://travel-uat.gettameeni.com",
  APP_URL: "https://travel-uat.gettameeni.com",
  OTP_TIMER: 3,
  SESSION_MAX_AGE: 120 * 60,
  IS_LOGIN_ENFORCE: true,
  NEXT_PUBLIC_GTM_ENABLED: "true",
  NEXT_PUBLIC_GTM_ID: "GTM-K7FZCSM",
  FILTER_MIN_QUOTATIONS: 4,
} satisfies ConfigContract;
